import { render, staticRenderFns } from "./noData.vue?vue&type=template&id=24e4f59b"
import script from "./noData.vue?vue&type=script&lang=js"
export * from "./noData.vue?vue&type=script&lang=js"
import style0 from "./noData.vue?vue&type=style&index=0&id=24e4f59b&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e4f59b')) {
      api.createRecord('24e4f59b', component.options)
    } else {
      api.reload('24e4f59b', component.options)
    }
    module.hot.accept("./noData.vue?vue&type=template&id=24e4f59b", function () {
      api.rerender('24e4f59b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/noData.vue"
export default component.exports